import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import ThankYou from "@/pages/ThankYou";
const ThankYouRoute = () => <ThankYou variant="signing-up-nw" />;

export const Route = createFileRoute("/en/thank-you/signing-up-nw")({
  head: () => buildRouteHead("/en/thank-you/signing-up-nw"),
  component: ThankYouRoute,
});

